import React, { createContext, useContext, useState } from 'react';

interface ExternalTriggerContextType {
  isOpen: boolean;
  data: any;
  openPortal: (data: any) => void;
  closePortal: () => void;
}

const ExternalTriggerContext = createContext<ExternalTriggerContextType | undefined>({
  isOpen: false,
  data: null,
  openPortal: () => {},
  closePortal: () => {},
});

export const ExternalTriggerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<any>(null);

  const openPortal = (portalData: any) => {
    setData(portalData);
    setIsOpen(true);
  };

  const closePortal = () => {
    setIsOpen(false);
    setData(null);
  };

  return (
    <ExternalTriggerContext.Provider value={{ isOpen, data, openPortal, closePortal }}>
      {children}
    </ExternalTriggerContext.Provider>
  );
};

export const useExternalTrigger = () => {
  const context = useContext(ExternalTriggerContext);
  return context;
};
